/**
 * Ten serwis odpowiada za walidację pola input, umożliwiając wpisywanie
 * wyłącznie cyfr oraz znaku specjalnego: przecinka (,).
 * Wciśnięcie kropki (.) automatycznie zamienia ją na przecinek (,).
 */
app.service('percentageShare', function () {

	function insertAtCaret($el, text) {
		const el = $el[0];
		const start = el.selectionStart;
		const end = el.selectionEnd;
		const value = el.value;
		el.value = value.substring(0, start) + text + value.substring(end);
		el.selectionStart = el.selectionEnd = start + text.length;
	}

	function init($percentageShare) {
		$percentageShare.on('keydown paste', function (e) {
			const controlKeys = [
				'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
				'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'
			];

			if (controlKeys.includes(e.key)) {
				return;
			}
			if (e.key >= '0' && e.key <= '9') {
				return;
			}
			if (e.key === ',') {
				return;
			}
			if (e.key === '.') {
				e.preventDefault();
				insertAtCaret($percentageShare, ',');
				return;
			}
			e.preventDefault();
		});
	}

	return {
		init
	};
});
